import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-244971ca")

_pushScopeId("data-v-244971ca")
const _hoisted_1 = {
  key: 0,
  class: "videoNode"
}
const _hoisted_2 = { class: "knowledgePoints" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "知识点", -1)
const _hoisted_4 = { class: "nodeStyle" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "时间节点", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_VideoOutline = _resolveComponent("VideoOutline")
  const _directive_contextmenu = _resolveDirective("contextmenu")

  return (_openBlock(), _createBlock("div", {
    class: ["editable-element-image", { 'lock': _ctx.elementInfo.lock }],
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px'
    }
  }, [
    _createVNode("div", {
      class: "rotate-wrapper",
      style: { transform: `rotate(${_ctx.elementInfo.rotate}deg)` }
    }, [
      _withDirectives(_createVNode("div", {
        class: ['element-content',{'element-content-cursor': _ctx.elementInfo.videoSource}],
        style: {
          filter: _ctx.shadowStyle ? `drop-shadow(${_ctx.shadowStyle})` : '',
          transform: _ctx.flipStyle,
        },
        onMousedown: _cache[1] || (_cache[1] = $event => _ctx.handleSelectElement($event))
      }, [
        _createVNode(_component_VideoOutline, { elementInfo: _ctx.elementInfo }, null, 8, ["elementInfo"]),
        _createVNode("div", {
          class: ['image-content', {'image-content-overflow': _ctx.elementInfo.videoSource}],
          style: { clipPath: _ctx.clipShape.style}
        }, [
          _createVNode("video", {
            id: 'video' + _ctx.elementInfo.id + _ctx.history,
            class: "video-js vjs-big-play-centered",
            style: {
              top: _ctx.imgPosition.top,
              left: _ctx.imgPosition.left,
              width: _ctx.imgPosition.width,
              height: _ctx.imgPosition.height,
            }
          }, [
            _createVNode("source", {
              src: _ctx.elementInfo.src,
              type: "video/mp4"
            }, null, 8, ["src"]),
            _createVNode("source", {
              src: _ctx.elementInfo.src,
              type: "video/ogg"
            }, null, 8, ["src"]),
            _createVNode("source", {
              src: _ctx.elementInfo.src,
              type: "video/webm"
            }, null, 8, ["src"])
          ], 12, ["id"])
        ], 6)
      ], 38), [
        [_directive_contextmenu, _ctx.contextmenus]
      ]),
      (_ctx.elementInfo.videoSource && _ctx.elementInfo.marker.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode("div", {
                innerHTML: _ctx.elementInfo.actionPointKnowledges && _ctx.elementInfo.actionPointKnowledges.length > 0 ? _ctx.elementInfo.actionPointKnowledges[_ctx.pointIndex] : ''
              }, null, 8, ["innerHTML"])
            ]),
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elementInfo.marker, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: {'isSelected': index == _ctx.pointIndex},
                  onClick: ($event: any) => (_ctx.changeCurrentTime(index))
                }, [
                  _hoisted_6,
                  _createVNode("span", null, _toDisplayString(_ctx.s_to_hs(item.time)), 1),
                  _createVNode("span", null, _toDisplayString(item.text), 1)
                ], 10, ["onClick"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 6))
})